var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegistersIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.20741C0 3.11458 0.99416 2.19891 2.3301 1.95814V3.25926C2.3301 3.55381 2.64306 3.79259 3.02913 3.79259H12.9709C13.3569 3.79259 13.6699 3.55381 13.6699 3.25926V1.95814C15.0058 2.19891 16 3.11458 16 4.20741V11.9822C16 12.7875 15.9995 13.3595 15.9515 13.807C15.9043 14.2484 15.8144 14.5216 15.6698 14.7381C15.3794 15.173 14.916 15.5265 14.3461 15.7481C14.0623 15.8584 13.7042 15.927 13.1257 15.963C12.5391 15.9996 11.7895 16 10.734 16H5.26602C4.2105 16 3.46091 15.9996 2.8743 15.963C2.29585 15.927 1.93771 15.8584 1.65393 15.7481C1.08396 15.5265 0.620568 15.173 0.330155 14.7381C0.185562 14.5216 0.095733 14.2484 0.0484718 13.807C0.000543984 13.3595 0 12.7875 0 11.9822V4.20741ZM3.02913 6.51852C2.64306 6.51852 2.3301 6.7573 2.3301 7.05185C2.3301 7.3464 2.64306 7.58518 3.02913 7.58518H12.9709C13.3569 7.58518 13.6699 7.3464 13.6699 7.05185C13.6699 6.7573 13.3569 6.51852 12.9709 6.51852H3.02913ZM3.02913 10.3111C2.64306 10.3111 2.3301 10.5499 2.3301 10.8444C2.3301 11.139 2.64306 11.3778 3.02913 11.3778H8C8.38606 11.3778 8.69903 11.139 8.69903 10.8444C8.69903 10.5499 8.38606 10.3111 8 10.3111H3.02913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14477 0.317864C4.41153 0.114339 4.77333 0 5.15058 0H10.8494C11.2267 0 11.5885 0.11434 11.8552 0.317865C12.122 0.52139 12.2718 0.797429 12.2718 1.08526V2.72593H3.72816V1.08526C3.72816 0.797429 3.87802 0.52139 4.14477 0.317864Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegistersIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/registersIconSelected.b38ab33ec7dd6dfdde6c53f1fd803dc1.svg";